import { render, staticRenderFns } from "./ComplaintDetail.vue?vue&type=template&id=d2e0b80c&scoped=true&"
import script from "./ComplaintDetail.vue?vue&type=script&lang=js&"
export * from "./ComplaintDetail.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintDetail.vue?vue&type=style&index=0&id=d2e0b80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e0b80c",
  null
  
)

export default component.exports